import { Navigate, Outlet, useLocation } from "react-router";
import { useAuthenticatedUser } from "src/contexts/AuthenticatedUserContext";
import OverlayLoading from "../common/OverlayLoading/OverlayLoading";
import BreadcrumbContainer from "./Breadcrumb/BreadcrumbContainer";
import Drawer from "./Drawer/Drawer";
import NewNavigation from "./Header/NewNavigation";
import MobileDrawer from "./MobileDrawer/MobileDrawer";
import Overlay from "./MobileDrawer/Overlay";
import CloseOnNavigation from "./MobileDrawer/CloseOnNavigation";
import HelpDrawer from "./HelpDrawer/HelpDrawer";
import HelpRouteSync from "./HelpDrawer/HelpRouteSync";
import RouteMetadataSync from "./RouteMetadataSync";
import RouteAccessBoundary from "./RouteAccessBoundary";
import { RouteLabelsProvider } from "src/contexts/RouteLabelsContext";

import "./AppLayout.scss";

export default function AppLayout() {
    const location = useLocation();
    const { user } = useAuthenticatedUser();
    if (!user) return <OverlayLoading />;
    if (!user.roles?.["Global"]?.includes("BctStaff") &&
        !user.roles?.["Global"]?.includes("Admin") && location.pathname !== "/error/403") {
        return <><Navigate replace to="/error/403" /><OverlayLoading /></>;
    }
    return (
        <div>
            <CloseOnNavigation />
            <RouteLabelsProvider>
            <HelpRouteSync />
            <RouteMetadataSync />
            <NewNavigation />
            <div className="layout-container">
                <div className="desktop-layout-drawer">
                    <Drawer />
                </div>
                <div className="mobile-layout-drawer">
                    <MobileDrawer />
                    <Overlay />
                </div>
                <div className="layout-main">
                    <div style={{ height: "64px" }}></div>
                    <BreadcrumbContainer />
                    <RouteAccessBoundary><Outlet /></RouteAccessBoundary>
                </div>
                <div className="desktop-layout-help-drawer">
                    <HelpDrawer />
                </div>
            </div>
            </RouteLabelsProvider>
        </div>
    );
}
